import React from 'react';
import { Link } from 'react-router-dom';

const SidebarItem = ({
  item,
  currentUrlPath,
  setDropdownActive,
  dropdownActive,
}) => {
  const type = localStorage.getItem('type');
  const hasChildren = item.children && item.children.length > 0;

  const toggleDropdown = () => {
    setDropdownActive((prev) => ({
      ...prev,
      [item.title]: !prev[item.title], // use title as unique key
    }));
  };

  if (hasChildren) {
    return (
      <div>
        {/* Parent clickable */}
        <div
          onClick={toggleDropdown}
          className="list-group-item border-0 py-2 fs-9rem d-flex rounded align-items-center"
          style={{
            cursor: 'pointer',
            color: '#6C6767',
          }}
        >
          <div className="flex-fill">
            <i className={`fa ${item.icon} me-2`}></i> {item.title}
          </div>
          <i
            className={
              dropdownActive[item.title]
                ? 'fas fa-chevron-down fs-chevron-12'
                : 'fas fa-chevron-right pt-1 fs-chevron-12'
            }
          ></i>
        </div>

        {/* Children */}
        <div className={!dropdownActive[item.title] ? 'd-none' : 'container'}>
          {item.children.map(
            (child, index) =>
              child.auth.some((level) => level === type) && (
                <Link
                  key={index}
                  to={child.link}
                  className="list-group-item border-0 text-decoration-none py-2 fs-9rem"
                  style={{
                    cursor: 'pointer',
                    color:
                      currentUrlPath === child.link ? '#5156be' : '#6c757d',
                    fontWeight: currentUrlPath === child.link ? 600 : 0,
                  }}
                >
                  <span className="ps-4">{child.title}</span>
                </Link>
              )
          )}
        </div>
      </div>
    );
  } else {
    return (
      <Link
        to={item.link}
        className="list-group-item border-0 text-decoration-none py-2 fs-9rem"
        style={{
          cursor: 'pointer',
          color: currentUrlPath === item.link ? '#5156be' : '#6C6767',
          fontWeight: currentUrlPath === item.link ? 600 : 0,
        }}
      >
        <i className={`fa ${item.icon} me-2`}></i> {item.title}
      </Link>
    );
  }
};

export default SidebarItem;
